<script>
import PayUCardContent from './comp_PayUCardContent.vue'
export default {
	props: ['order', 'checkout'],
	extends: PayUCardContent,
}
</script>
